import { Add } from '@mui/icons-material'
import { useSelector } from 'react-redux'

import { ListHeaderActions, ListHeaderPrimaryActionButton } from '@/components/List'
import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { useIsLoading } from '@/atoms'
import { selectIsTelematicsUnavailable } from '@/features/domain/account'

import { useCanAddNewVehicle } from '../../../../../hooks/useCanAddNewVehicle'

import { useActions } from './hooks/useActions'
import { useTooltipTitle } from './hooks/useTooltipTitle'

export function Actions() {
  const { editing, onCreate } = useActions()
  const isLoading = useIsLoading('fetchGpsData')
  const isTelematicsUnavailable = useSelector(selectIsTelematicsUnavailable)
  const canAddNewVehicle = useCanAddNewVehicle(isLoading)

  const tooltipTitle = useTooltipTitle({
    editing,
    isLoading,
    canAddNewVehicle,
    isTelematicsUnavailable,
  })

  return (
    <ReadOnlyTooltip
      forceState="enabled"
      placement="bottom"
      canEdit={canAddNewVehicle && !isTelematicsUnavailable}
      title={tooltipTitle}
      render={preventEditing => (
        <ListHeaderActions>
          <ListHeaderPrimaryActionButton
            disabled={preventEditing || editing || !canAddNewVehicle || isTelematicsUnavailable}
            onClick={onCreate}
            trackId="pendo-vehicle__create-new-button"
          >
            <Add />
          </ListHeaderPrimaryActionButton>
        </ListHeaderActions>
      )}
    />
  )
}
